import { Link } from "react-router-dom";
import { history, store } from '../../store/store';
import { addParam } from '../../api/helper';
import { hideNotification } from '../../store/actions/notification';

function LinkResource(props) {
    const { displayText, resourceLink, resourceParamId} = props;
    return (
        <Link
          to="#"
          onClick={e => {
            e.preventDefault();
            store.dispatch(hideNotification());
            history.push(
              addParam(resourceLink, resourceParamId));
          }}>
            {displayText}
        </Link>
    );
}

export { LinkResource };